import { ClaimSums } from "src/types/claim-sum";

export type CaseTableItem = {
  id: string;
  payee_case_reference_id: string;
  jurisdiction: string;
  started_at: string | null;
  parties: {
    debtor_name: string | null;
    client_name: string;
  };
  state: {
    stage: Stage;
    state_label_text_color: string;
    state_label_background_color: string;
    state_label: string;
    stage_label: string;
  };
  partner: {
    integration: string;
    name: string;
  } | null;
  claim: ClaimSums;
  actions: {
    id: string;
    label: string;
    dialog: string;
  }[];
  is_deletable: boolean;
  deleted_at?: string | null;
  is_editable: boolean;
};

export type Pagination = {
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
};

export type GetCasesResponse = {
  data: CaseTableItem[];
  headers: never[];
  sortBy: never[];
  pagination: Pagination;
  counts?: Partial<Record<Stage, number>>;
};

export const stages = [
  'draft',
  'ongoing',
  'closed',
] as const;
export type Stage = typeof stages[number];

export const products = [
  'notice',
  'demand_letter',
  'hard_1',
  'hard_2',
] as const;
export type Product = typeof products[number];

export type ClientOption = {
  id: string;
  name: string;
};

export type StateOption = {
  id: string;
  label: string;
};

export type DebtorOption = {
  name: string;
};
